import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { LocalStorageServices } from '../../../../services/localStorageServices'
import { delete_hotel_booking, get_hotel_bookings_list_with_pagination } from '../../../../api/process_ecr/hotelBookingApis'
import CustomBottomPagination from '../../../../components/custom_bottom_pagination/CustomBottomPagination'
import CustomTable from '../../../../components/custom_table/CustomTable'
import { useSelector } from 'react-redux'
import { IconButton, Tooltip } from '@mui/material'
import { IoCloseCircleOutline } from 'react-icons/io5';
import { TiTickOutline } from 'react-icons/ti';
import { FaRegCirclePause } from "react-icons/fa6";
import { SiTicktick } from 'react-icons/si';
import { FaRegCommentAlt } from 'react-icons/fa';
import { LiaFileInvoiceSolid } from 'react-icons/lia';
import { PiEye } from 'react-icons/pi';
import { BiEditAlt } from 'react-icons/bi';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import HotelManagerLevelModal from './hotel_manager_level_modal/HotelManagerLevelModal'
import HotelFinanceLevelModal from './hotel_finance_level_modal/HotelFinanceLevelModal'
import HotelCfoLevelModal from './hotel_cfo_level_modal/HotelCfoLevelModal'
import HotelCancelModal from './hotel_cancel_modal/HotelCancelModal'
import HotelCommentModal from './hotel_comment_modal/HotelCommentModal'
import PackageInvoiceDetailsModal from '../packages/package_invoice_details_modal/PackageInvoiceDetailsModal'
import HotelInvoiceDetailsModal from './hotel_invoice_details_modal/HotelInvoiceDetailsModal'
import HotelFilter from './hotel_filter/HotelFilter'
import CustomDeleteConfirmModal from '../../../../components/custom_delete_confirm_modal/CustomDeleteConfirmModal'
import { delete_hotel_by_id } from '../../../../api/hotelApis'
import { ErrorToast, SuccessToast } from '../../../../toast/toasts'
import { hasPrivilege } from '../../../../common_privilige_methods/Privilege_Methods'

function Hotels() {
  const baseRouteUrl = `/ecrs_portal/${LocalStorageServices.getUserRole()}/process_ecr`
  const filter_data_store = useSelector((state) => state.commonStore.notification_redirect)
  const [managerLevelModal, setManagerLevelModal] = useState(false)
  const [financeLevelModal, setFinanceLevelModal] = useState(false)
  const [cfoLevelModal, setCFOLevelModal] = useState(false)
  const [hotelBookings, setHotelBookings] = useState([])
  const [pageNumber, setPageNumber] = useState(1)
  const [totalPages, setTotalPages] = useState(0)
  const [totalItemPerPage, setTotalItemPerPage] = useState(10)
  const [searchFilter, setSearchFilter] = useState(null)
  const [selectedItem, setSelectedItem] = useState(null)
  const [bookingCancelModal, setBookingCancelModal] = useState(false);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);

  const [commentModal, setcommentModal] = useState(false)
  const [invoiceDetailsModal, setInvoiceDetailsModal] = useState(false)
  const navigate = useNavigate()
  useEffect(() => {
    if (!filter_data_store?.filter_data) {
      getList(pageNumber, searchFilter)
    }
  }, [pageNumber,totalPages,managerLevelModal, financeLevelModal, cfoLevelModal, bookingCancelModal, deleteConfirmation])
  const getList = (pageNumber, filterValue) => {
    const formData = new FormData();
    formData.append('page', pageNumber);
    formData.append('pageItem_count', totalItemPerPage);
    if (filterValue) {
      for (const key in filterValue) {
        formData.append(key, filterValue[key] ?? '');
      }
    }
    get_hotel_bookings_list_with_pagination(formData).then((response) => {
      if (response.data.code === 200) {
        setHotelBookings(response?.data.data)
        setTotalPages(response.data.pagination?.last_page)
      } else {
        setHotelBookings([])
        if (pageNumber > 1) {
          setPageNumber(pageNumber - 1)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  }
  const Columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",

    },
    {
      title: "Enquiry Number",
      dataIndex: "enquiry_number",
      key: "enquiry_number",
    },
    {
      title: "Hotel Name",
      dataIndex: "hotel_name",
      key: "hotel_name",
    },
    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Check In",
      dataIndex: "check_in",
      key: "check_in",
    },

    {
      title: "Check Out",
      dataIndex: "check_out",
      key: "check_out",
    },
    {
      title: "Client",
      dataIndex: "client",
      key: "client",
    },
    {
      title: "Supplier",
      dataIndex: "supplier",
      key: "supplier",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      action: (row) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', 'gap': 5 }} >
            {isPrivileges_View && <IconButton>
              <PiEye className='packages_action_view' onClick={() => {
                navigate(baseRouteUrl + `/${row.id}/view_hotel_booking`)
              }} />
            </IconButton>}

            {/* Staff Action handle */}
            {((row.ecr_status == 1 || row.ecr_status == 6) && (isPrivileges_Edit)) ? (
              <>
                <IconButton>
                  <BiEditAlt className='packages_action_edit' onClick={() => {
                    navigate(baseRouteUrl + `/${row.id}/update_hotel_booking`)
                  }} />
                </IconButton>

                {isPrivileges_Delete && <Tooltip title="Delete" placement="top">
                  <IconButton>
                    <MdOutlineDeleteOutline className='packages_action_delete' onClick={() => {
                      setSelectedItem(row)
                      setDeleteConfirmation(true)
                    }} />
                  </IconButton>
                </Tooltip>
                }
              </>

            ) : <></>}
            {row.ecr_status == 5 ? (
              <>
                {isPrivileges_Cancel && <Tooltip title="Cancel" placement="top">
                  <IconButton>
                    <IoCloseCircleOutline className='flight_ticket_action_cancel_ticket' onClick={() => {
                      setSelectedItem(row)
                      setBookingCancelModal(true)
                    }} />
                  </IconButton>
                </Tooltip>

                }
              </>
            ) : <></>}
          </div>
          {/* Finance Action handle */}
          {row.ecr_status === 3 || row.ecr_status === 6 ? (
            <>
              {isPrivileges_Hold && <Tooltip title="Hold" placement="top">
                <IconButton onClick={() => {
                  //setfinanceLevelModal old code
                  setFinanceLevelModal(true)
                  setSelectedItem({ ...row, 'type': 'Hold' })
                }}>
                  <FaRegCirclePause className='flight_ticket_action_onhold' />
                </IconButton>
              </Tooltip>}
            </>
          ) : <></>}

          {row.ecr_status === 3 || row.ecr_status === 7 || row.ecr_status === 6 ? (
            <>
              {isPrivileges_Verify && <Tooltip title="Verify" placement="top">
                <IconButton onClick={() => {
                  setFinanceLevelModal(true)
                  setSelectedItem({ ...row, 'type': 'Verify' })
                }}>
                  <SiTicktick className='flight_ticket_action_verified' />
                </IconButton>
              </Tooltip>}
            </>
          ) : <>
            {/* FOR HANDLE PACKAGE CANCELATION VERIFY BY FINANCE */}
            {row.ecr_status === 11 && isPrivileges_Verify && <Tooltip title="Verify" placement="top">
              <IconButton onClick={() => {
                setFinanceLevelModal(true)
                setSelectedItem({ ...row, 'type': 'CancelVerified' })
              }}>
                <SiTicktick className='flight_ticket_action_verified' />
              </IconButton>
            </Tooltip>}</>}
          {/*Manager Action handle  and also check submitted status  */}
          {(row.ecr_status === 2) ? <>
            {isPrivileges_Review && <Tooltip title="Review" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Review' })
                  setManagerLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}
            {isPrivileges_Reject && <Tooltip title="Reject" placement="top">
              <IconButton>
                <IoCloseCircleOutline className='flight_ticket_action_reject' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Reject' })
                  setManagerLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}

          </> : (row.ecr_status === 10) ? <>
            {/* FOR HANDLE PACKAGE CANCELATION REVIEW BY MANAGER */}
            {isPrivileges_Review && <Tooltip title="Review" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'CancelReviewed' })
                  setManagerLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}

          </> : <></>}

          {/* //CFO */}
          {(row.ecr_status === 4) ? <>
            {isPrivileges_Approve && <Tooltip title="Approve" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Approve' })
                  setCFOLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}

            {isPrivileges_Reject && <Tooltip title="Reject" placement="top">
              <IconButton>
                <IoCloseCircleOutline className='flight_ticket_action_reject' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'Approve' })
                  setCFOLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}
            {/* FOR HANDLE PACKAGE CANCELATION Approve BY CFO */}
          </> : <>{row.ecr_status === 12 && <>
            {isPrivileges_Approve && <Tooltip title="Approve" placement="top">
              <IconButton>
                <TiTickOutline className='flight_ticket_action_approve' onClick={() => {
                  setSelectedItem({ ...row, 'type': 'CancelApproved' })
                  setCFOLevelModal(true)
                }} />
              </IconButton>
            </Tooltip>}</>}</>}
          {true && (
            <IconButton>
              <FaRegCommentAlt className='flight_ticket_action_comment' onClick={() => {
                setSelectedItem({ ...row })
                setcommentModal(true)
              }} />
            </IconButton>
          )}
          {(row.ecr_status === 4 || row.ecr_status === 5 || row.ecr_status === 6 || row.ecr_status === 7 || row.ecr_status === 8) && (row?.invoice?.length !== 0) &&
            <Tooltip title="Invoice" placement="top">
              <IconButton>
                <LiaFileInvoiceSolid className='flight_ticket_action_invoice' onClick={() => {
                  setInvoiceDetailsModal(true)
                  setSelectedItem({ ...row })
                }} />
              </IconButton>
            </Tooltip>
          }

        </div>
      ),
    },
  ];
  const datas = () => {
    const result =
      hotelBookings &&
      hotelBookings.map((item, index) => {
        return {
          key: pageNumber * totalItemPerPage - (totalItemPerPage - (index + 1)),
          id: item.booking_id,
          enquiry_number: item.enquiry_number,
          hotel_name: item.hotel,
          issue_date: item.issue_date,
          check_in: item.checkIn,
          check_out: item.checkOut,
          supplier: item.supplier,
          client: item.client,
          clientAmount: item.client_amount,
          status: item.status,
          invoice: item.invoice,
          ecr_status: item.status_id,
          is_highlight_row: (item?.status === `Cancelled` || item?.status === `Cancellation Initiated` || item?.status === `Cancellation Reviewed` || item?.status === `Cancellation Verified`) ? true : false,
          highlight_color: item?.status === `Cancelled` || item?.status === `Cancellation Initiated` || item?.status === `Cancellation Reviewed` || item?.status === `Cancellation Verified` ? 'red' : ''
        };
      });
    return result;
  };
  const updatePagination = (pageNumber) => {
    setPageNumber(pageNumber)
  }
  const updateItemPageCount = (pageItemCount) => {
    setTotalItemPerPage(pageItemCount)
  }
  const searchfilter = (value) => {
    setSearchFilter(value)
    if (value) {
      getList(pageNumber, value)
    } else {
      getList(1, value)
      setPageNumber(1)
    }
  }
  const handleManagerLevelModalClose = (is_close) => {
    setManagerLevelModal(is_close)
    setSelectedItem(null)
  };
  const handleFinanceLevelModalClose = (is_close) => {
    setFinanceLevelModal(is_close)
    setSelectedItem(null)
  };
  const handleCFOLevelModalClose = (is_close) => {
    setCFOLevelModal(is_close)
    setSelectedItem(null)
  };
  const handleCancelBookingModalClose = (is_close) => {
    setBookingCancelModal(is_close)
    setSelectedItem(null)
  };
  const handleCommentModalClose = (is_close) => {
    setcommentModal(is_close)
    setSelectedItem(null)
  };
  const handleInvoiceDetailsModalClose = (is_close) => {
    setInvoiceDetailsModal(is_close)
    setSelectedItem(null)
  };
  const deleteHotelBooking = () => {
    if (selectedItem?.id) {
      const payload = {
        booking_id: selectedItem?.id
      }
      delete_hotel_booking(payload).then((response) => {
        if (response.code === 200) {
          handleDeleteModalClose(false)
          SuccessToast(response?.message)
        }
      }).catch((error) => {
        handleDeleteModalClose(false)
        ErrorToast(error?.data?.message)
      })
    }
  }
  const handleDeleteModalClose = (is_close) => {
    setDeleteConfirmation(is_close);
    setSelectedItem(null)
  };

  const isPrivileges_Add = hasPrivilege("Process ECR", "Hotel", "Add");
  const isPrivileges_View = hasPrivilege("Process ECR", "Hotel", "View");
  const isPrivileges_Edit = hasPrivilege("Process ECR", "Hotel", "Edit");
  const isPrivileges_Delete = hasPrivilege("Process ECR", "Hotel", "Delete");
  const isPrivileges_Hold = hasPrivilege("Process ECR", "Hotel", "Hold");
  const isPrivileges_Cancel = hasPrivilege("Process ECR", "Hotel", "Cancel");
  const isPrivileges_Reject = hasPrivilege("Process ECR", "Hotel", "Reject");
  const isPrivileges_Review = hasPrivilege("Process ECR", "Hotel", "Review");
  const isPrivileges_Verify = hasPrivilege("Process ECR", "Hotel", "Verify");
  const isPrivileges_Approve = hasPrivilege("Process ECR", "Hotel", "Approve");


  return (
    <div className='packages_module_main_container'>
      <p className='packages_title'>Hotel</p>
      <div>

        <div className='user_module_filter'>
          <HotelFilter searchFilter={searchfilter} />
          {isPrivileges_Add && <button className='packages_add_button' onClick={() => {
            navigate(baseRouteUrl + `/create_new_hotel_booking`)
          }}>Add New</button>}
        </div>
        <div className='packages_table_main_container'>
          <CustomTable columns={Columns} rows={datas()} />
        </div>
        <div>
          <CustomBottomPagination total_items_per_page={totalItemPerPage} total_page_count={totalPages} current_page={pageNumber} on_change_value={updatePagination} on_page_count_update={updateItemPageCount} />
        </div>
        <div>
          {managerLevelModal && (<HotelManagerLevelModal selected_item={selectedItem} open_modal={managerLevelModal} modal_close={handleManagerLevelModalClose} />)}
          {financeLevelModal && (<HotelFinanceLevelModal selected_item={selectedItem} open_modal={financeLevelModal} modal_close={handleFinanceLevelModalClose} />)}
          {cfoLevelModal && (<HotelCfoLevelModal selected_item={selectedItem} open_modal={cfoLevelModal} modal_close={handleCFOLevelModalClose} />)}
          {bookingCancelModal && (<HotelCancelModal selected_item={selectedItem} open_modal={bookingCancelModal} modal_close={handleCancelBookingModalClose} />)}

          {commentModal && (<HotelCommentModal open={commentModal} handleClose={handleCommentModalClose} booking_id={selectedItem?.id} />)}
          {invoiceDetailsModal && <HotelInvoiceDetailsModal selected_item={selectedItem} open_modal={invoiceDetailsModal} modal_close={handleInvoiceDetailsModalClose} />}

          {<CustomDeleteConfirmModal module_name={'Hotel Booking'} open_modal={deleteConfirmation} close_modal={handleDeleteModalClose} confirm_function={deleteHotelBooking} />}
        </div>
      </div>
    </div>
  )
}

export default Hotels